// @noflow
import './calendar-month.component.css';

import CalendarDays from '../days/calendar-days.component';
import classnames from 'classnames';
import { FormattedDate } from 'react-intl';
import { isSameMonth } from 'instadate';
import PropTypes from 'prop-types';
import * as React from 'react';

export default class CalendarMonth extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        dateToRender: PropTypes.object.isRequired,
        displaySingleActive: PropTypes.bool,
        endDate: PropTypes.instanceOf(Date),
        fixedMonth: PropTypes.number,
        handleDateSelected: PropTypes.func.isRequired,
        startDate: PropTypes.instanceOf(Date)
    };

    shouldComponentUpdate(nextProps) {
        const { dateToRender: nextDate } = nextProps;
        const { dateToRender: currentDate, fixedMonth } = this.props;
        //// fixedMonth is used to force the calendar days component to not re-render a new month
        if (fixedMonth !== undefined) {
            if (fixedMonth === nextDate.getMonth() && isSameMonth(nextDate, currentDate)) {
                return true;
            }
            return false;
        }

        return true;
    }

    render() {
        const { dateToRender, startDate, endDate, handleDateSelected, className, displaySingleActive } = this.props;

        return (
            <div className={classnames('calendar-month', className)}>
                <h3 className="calendar-month__month">
                    <span data-qa="calendar-month">
                        <FormattedDate month="short" value={dateToRender} />
                    </span>
                    &nbsp;
                    <span className="calendar-month__year" data-qa="calendar-year">
                        <FormattedDate value={dateToRender} year="numeric" />
                    </span>
                </h3>
                <CalendarDays
                    dateToRender={dateToRender}
                    displaySingleActive={displaySingleActive}
                    endDate={endDate}
                    handleDateSelected={handleDateSelected}
                    startDate={startDate}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/calendar/month/calendar-month.component.js